import React from "react";
import useUpdateDomTitle from "../utils/updateDomTitle";
import { useParams } from "react-router-dom";

let NoData = (props) => {

  const domain = process.env.REACT_APP_DOMAIN;
  const title = domain === "qga" ? "View Page" : "Scan Page";

  useUpdateDomTitle(title + " | No Data");

  return <div className="w-full h-[100vh] flex items-center justify-center bg-green-50">
    <img src="/No data.svg" style={{width:'300px'}} alt="no data" />
  </div>;
};

export default NoData;
